import React from "react";
import iosAndroid from "../../assets/img/web-i-os-android.png";
import StoreButtons from "../generic/StoreButtons";

export default function AccessibleSection() {
  return (
    <section className="accessible-section text-center p-t-80 p-b-20">
      <div className="container">
        <div className="row">
          <div className="col-10 offset-1">
            <h2 className="h2 semi-bold text-white">Universally Accessible</h2>
            <h4 className="h4 light text-white m-t-20">
              Get verified e-certificate at completion of each course. You can
              share the certificate on your resume and popular platforms such as
              LinkedIn.
            </h4>
            <div className="m-t-40">
              <StoreButtons />
            </div>
          </div>
        </div>
        <div className="m-t-80">
          <picture>
            <source
              type="image/webp"
              srcSet={`${'https://storage.googleapis.com/programminghub/landing_page/1/web-i-os-android.webp'}, ${'https://storage.googleapis.com/programminghub/landing_page/1/web-i-os-android%402x.webp'} 2x, ${'https://storage.googleapis.com/programminghub/landing_page/1/web-i-os-android%402x.webp'} 3x`}
            />

            <img
              src={'https://storage.googleapis.com/programminghub/landing_page/2/web-i-os-android.png'}
              srcSet={`${'https://storage.googleapis.com/programminghub/landing_page/2/web-i-os-android%402x.png'} 2x,
                    ${'https://storage.googleapis.com/programminghub/landing_page/2/web-i-os-android%403x.png'} 3x`}
              className="img-fluid"
              alt="Web Ios Android"
            />
          </picture>
        </div>
      </div>
    </section>
  );
}
